exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nested[data-v-7ec0c510] {\n  color: #409e55;\n}\n.numStat[data-v-7ec0c510] {\n  background-color: rgba(64, 158, 255, 0.1);\n  display: inline-block;\n  padding: 0 10px;\n  height: 32px;\n  line-height: 30px;\n  font-size: 12px;\n  color: #409eff;\n  border-radius: 4px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 1px solid rgba(64, 158, 255, 0.2);\n  white-space: nowrap;\n}\n.el-select.big[data-v-7ec0c510] {\n  width: 440px;\n}\n.el-select.biggest[data-v-7ec0c510] {\n  width: 1100px;\n}\n.el-select.countries[data-v-7ec0c510] {\n  width: 440px;\n}\n.searchButton[data-v-7ec0c510] {\n  margin-left: 30px;\n}\n.el-input[data-v-7ec0c510] {\n  width: 200px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ec0c510","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Statistics.vue
// module id = rXOn
// module chunks = 1